import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@microservices/wiskey-react-components'
import { Add } from '@mui/icons-material'
import { Grid } from '@mui/material'

import { Event } from '@pages/WindowsCreateOrEdit/components/Event/Event'
import { EventEdit } from '@pages/WindowsCreateOrEdit/components/Event/EventEdit'

import { getEmptyEvent } from '../helpers'

import { useEvents } from './hooks'

type EventsProps = {
  sectionIndex: number
  tabIndex: number
  actionIndex: number
}

export const Events: FC<EventsProps> = ({ sectionIndex, tabIndex, actionIndex }) => {
  const { t } = useTranslation()

  const {
    events,
    isCreateEvent,
    handleAddEvent,
    handleSaveNewEvent,
    handleCancelCreate,
    removeEvent,
  } = useEvents({ sectionIndex, tabIndex, actionIndex })

  return (
    <>
      {events.map((field, index) => (
        <Event
          key={field.id}
          actionIndex={actionIndex}
          eventIndex={index}
          removeEvent={removeEvent}
          sectionIndex={sectionIndex}
          tabIndex={tabIndex}
        />
      ))}
      {isCreateEvent && (
        <EventEdit
          initialValues={getEmptyEvent()}
          sectionIndex={sectionIndex}
          tabIndex={tabIndex}
          onCancel={handleCancelCreate}
          onSave={handleSaveNewEvent}
        />
      )}
      <Grid container justifyContent={'flex-end'} pb={1} width={'100%'}>
        <Button disabled={isCreateEvent} onClick={handleAddEvent}>
          <Add fontSize='small' />
          {t('window.buttons.addEvent')}
        </Button>
      </Grid>
    </>
  )
}
